import { useParams, useSearchParams, usePathname } from 'next/navigation'
import { useDispatch, useSelector } from 'react-redux'
import {
  setInitialCalendarData,
  setCalendarData,
  setPreLoadedCalendarFormData
} from '@/store/slices/components/calendar/CalendarSlice'
import CalendarService from '@/services/CalendarService'
import Trans from '@/components/shared/Trans'
import translations from '../calendarLayout/calendarLayout.trans.json'

export default function useHandleInitialCalendarData () {
  const dispatch = useDispatch()
  const fichaInfo = useSelector(state => state.FichaInfoSlice)
  const calendar = useSelector(state => state.CalendarSlice)
  const params = useParams()
  const searchParams = useSearchParams()
  const pathname = usePathname()

  const handleContactInfoData = () => {
    dispatch(setPreLoadedCalendarFormData({
      fullname: fichaInfo.contact_name,
      email: fichaInfo.contact_email,
      phone: fichaInfo.contact_phone,
    }))
  }

  const handleDataFromSSR = (data) => {
    if (data.company_language) {
      localStorage.setItem('lang', data.company_language)
    }
    dispatch(setInitialCalendarData({ ...data }))
    handleContactInfoData()
    document.title = `${Trans(translations, 'VisitToPropertyAddress', data.direction)} | ${Trans(translations, "ReservationSystem")}`
  }

  const fetchInitialData = async () => {
    try {
      const propertyId = pathname.includes('/calendar/') ? params.id : calendar.property.id
      const contactId = searchParams.get('contact_id')
      dispatch(setCalendarData({ key: 'schedule', subkey: 'initializing', value: true }))

      const [schedule, contactInformation] = await Promise.all([
        CalendarService.getPropertySchedule({ propertyId, host: calendar.host }),
        CalendarService.getContactInfo({ propertyId, contactId, host: calendar.host })
      ])

      const data = {
        ...schedule,
        ...contactInformation,
        property_id: propertyId,
        host: calendar.host
      }

      dispatch(setInitialCalendarData({ ...data }))
      handleContactInfoData()
    } catch (error) {
      console.log(error)
    }
  }

  return {
    handleDataFromSSR,
    fetchInitialData
  }
}
